import React, { useContext, useEffect, useRef, useState } from 'react';
import {
    DataGrid,
    GridToolbar,
    gridClasses,
    GridActionsCellItem,
    GridRowModes,
    GridRowEditStopReasons
} from '@mui/x-data-grid';
import {
    Box,
    Typography,
    Paper,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Card,
    ImageList,
    ImageListItem,
    IconButton,
    DialogContentText
} from '@mui/material';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import BugReportIcon from '@mui/icons-material/BugReport';
import { axiosInstances, coil_number, delete_issue, delete_order_issue, get_inspection_list, get_inspection_report, get_issues_list, getLookupData, getOrderDataByID, imageURL, save_issue_list } from '../../constant/url';
import axios from 'axios';
import { AccessContext } from '../../constant/accessContext';
import { toast } from 'react-toastify';
import debounce from 'debounce';
import { maxWidth, width } from '@mui/system';
import { Build, Cancel, CheckCircle, Help } from '@mui/icons-material';
import { handleFindCoverDetailLookup_arr, handleFindLookup_arr } from '../../commonjs/CommonFun';
import CloseIcon from '@mui/icons-material/Close';
import { ClearIcon } from '@mui/x-date-pickers';
import DeleteIcon from '@mui/icons-material/Delete';
import PuffLoader from "react-spinners/PuffLoader";

const QualityInspectionReport = ({ selectedRow }) => {



    let orderRowID = selectedRow?.id;



    const access = useContext(AccessContext).authID;
    const [selectrow, setSelectrow] = useState([]);

    console.log(selectrow);

    useEffect(() => {
        setSelectrow([selectedRow]);
    }, [selectedRow]);




    useEffect(() => {
        const serialNo = selectrow[0]?.serial_no;
        const coilSerialNo = selectrow[0]?.coil_serial_no;
        const firstSerial = serialNo && serialNo.trim() !== ""
            ? serialNo.split(',').filter(s => s.trim() !== "")[0]?.trim()
            : coilSerialNo;
        setInputValue(firstSerial);
    }, [selectrow]);

    const [epPhoto, setEpPhoto] = useState([]);
    const [assemblyPhoto, setAssemblyPhoto] = useState([]);
    const [brazingPhoto, setBrazingPhoto] = useState([]);

    console.log(epPhoto);
    console.log(assemblyPhoto);
    console.log(brazingPhoto);

    const [tempSerialNumber, setTempSerialNumber] = useState('');
    const [inputValue, setInputValue] = useState(tempSerialNumber);

    const [rows, setRows] = useState([]);
    const globalData = [];
    const hasMounted = useRef(false);

    const hasFetchedOnce = useRef(false);

    useEffect(() => {
        if (!inputValue) return;

        if (!hasFetchedOnce.current && selectedRow?.coil_serial_no === inputValue) {
            setTempSerialNumber(inputValue); // update state directly
            hasFetchedOnce.current = true;  // mark as fetched to allow future calls
            return;
        }


        const fetchCoilNumber = async () => {
            const bodyFormData = new FormData();
            bodyFormData.append("authId", access);
            bodyFormData.append("order_id", selectedRow?.order_id);
            bodyFormData.append("coil_serial_no", inputValue);

            try {
                const response = await axios.post(coil_number, bodyFormData);

                const serialNo = response?.data?.data?.serial_no;
                const coilSerialNo = response?.data?.data?.coil_serial_no;

                const displaySerial =
                    serialNo && String(serialNo).trim() !== ""
                        ? String(serialNo).split(',')[0].trim()
                        : coilSerialNo;

                setTempSerialNumber(displaySerial);

                if (hasMounted.current) {
                    toast.success("Coil serial number successfully updated");
                } else {
                    hasMounted.current = true;
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchCoilNumber();
    }, [inputValue, selectedRow?.coil_serial_no]);





    // useEffect(()=>{
    //      if (selectedRow?.coil_serial_no) {
    //     setTempSerialNumber(selectedRow?.coil_serial_no); // still update the local state
    //     return;
    // }

    // },[selectedRow?.coil_serial_no])




    const [lookUpList, setLookupList] = useState([]);

    function handleGetLookup() {
        var bodyFormData = new FormData();
        bodyFormData.append("authId", access);

        axios({
            method: "post",
            url: getLookupData,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                //handle success
                const res_data = response.data;
                if (res_data.status_code === 200) {
                    setLookupList(res_data);
                } else {
                    toast(res_data.status_msg, "error");
                }
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }


    useEffect(() => {
        handleGetLookup();
        // handleOrderList(access);
    }, []);


    const [inspectionList, setInspectionList] = useState([]);

    const [message, setmessage] = useState(false)


    let endplateFinalStatus;
    let pipeFinalStatus;
    let finFinalStatus;
    let assemblyFinalStatus;
    let brazingFinalStatus;
    let packingFinalStatus;

    const [dialogImages, setDialogImages] = useState([]);




    const handleShowImages = (imageKey) => {
        // console.log(imageKey);
        // console.log(epPhoto);

        // const imageMap = {
        //     endPlateImages: epPhoto,
        //     assemblyImages: assemblyPhoto,
        //     brazingImages: brazingPhoto,
        // };

        // const images = imageMap[imageKey] || [];
        setDialogImages(imageKey);
        setOpenDialog(true);
    };



    const handleCloseDialog = () => {
        setOpenDialog(false);
        setDialogImages([]);
    };


    const getThickValue = (finPerInch) => {
        const mapper = {
            T: "0.15mm Thick",
            H: "0.13mm Thick",
            B: "0.12mm Thick Hydrophilic blue Aluminum",
            C: "0.12mm Thick Copper Fins",
            S: "0.105mm Thick",
            U: "0.20mm Thick",
            H: "0.13mm Thick",
            I: "0.13mm Thick Hydrophilic Blue Aluminium",
            PP: "Not Applicable",
        };
        if (finPerInch.includes("-")) {
            finPerInch = finPerInch.split("-")[0].trim().toUpperCase();
        }
        if (typeof finPerInch === "string") {
            finPerInch = finPerInch.toUpperCase();
        }
        if (mapper[finPerInch]) {
            return mapper[finPerInch];
        } else {
            // If value is not found in mapper, return a default value
            return "0.12mm Thick"; // You can set your default value here
        }
    };


    const rawOrderId = selectrow[0]?.order_id || '';
    const suffix = rawOrderId.replace(/[0-9]/g, "");
    const cleanedOrderId = rawOrderId.replace(/\D/g, '');

    useEffect(() => {



        const fetchAndGenerate = async () => {

            if (
                cleanedOrderId === undefined ||
                cleanedOrderId === null ||
                cleanedOrderId.toString().trim() === "" ||
                inputValue === undefined ||
                inputValue === null ||
                inputValue.toString().trim() === ""
            ) {
                console.warn("Skipped API call: cleanedOrderId or inputValue is undefined, null, or empty");
                return;
            }

            if (selectrow && Array.isArray(selectrow)) {
                try {
                    const bodyFormData = new FormData();
                    bodyFormData.append("authId", access);
                    bodyFormData.append("order_id", cleanedOrderId);
                    bodyFormData.append("coil_serial_no", inputValue);

                    const response = await axios.post(get_inspection_list, bodyFormData);
                    const data = response?.data?.data || [];
                    setInspectionList(data);


                    const allGeneratedRows = [];

                    for (let index = 0; index < selectrow.length; index++) {
                        const item = selectrow[index];

                        globalData.push({
                            id: item?.id,
                            orderId: item?.order_id,
                        });

                        const lengthEval = await evaluateInspection('Length', data);
                        const heightEval = await evaluateInspection('Height', data);
                        const rowsEval = await evaluateInspection('Rows', data);
                        const endplateMaterialEval = await evaluateInspection('Endplate Material', data);
                        const endplateModelEval = await evaluateInspection('Endplate Model', data);
                        const endplateOrientationEval = await evaluateInspection('Endplate Orientation', data);
                        const coverDetailEval = await evaluateInspection('Cover Detail', data);
                        const pipeTypeEval = await evaluateInspection('Pipe Type', data);
                        const straightPipeEval = await evaluateInspection('Straight Pipe', data);
                        const singlePipeEval = await evaluateInspection('Single Pipe', data);
                        const crossPipeEval = await evaluateInspection('Cross Pipe', data);
                        const otherPipeEval = await evaluateInspection('Other Pipe', data);
                        const finsPerInchEval = await evaluateInspection('Fins Per Inch', data);
                        const finThicknessEval = await evaluateInspection('Fin Thickness', data);
                        const afterCoilEval = await evaluateInspection('After Coil Assembly (Drawing / Sample)', data);
                        const circuitEval = await evaluateInspection('Circuit', data);
                        const feedingEval = await evaluateInspection('Feeding', data);
                        const liquidLineEval = await evaluateInspection('Liquid Line', data);
                        const dischargeLineEval = await evaluateInspection('Discharge Line', data);
                        const afterBrazingEval = await evaluateInspection('After Brazing (Drawing / Sample)', data);
                        const paintTypeEval = await evaluateInspection('Paint Type', data);
                        const packingTypeEval = await evaluateInspection('Packing Type', data);



                        const endplateStatuses = [
                            lengthEval.status,
                            heightEval.status,
                            rowsEval.status,
                            endplateMaterialEval.status,
                            endplateModelEval.status,
                            endplateOrientationEval.status,
                            coverDetailEval.status,
                        ];

                        const isEndplateSectionPass = endplateStatuses.every(status => {
                            const normalized = status?.toLowerCase();
                            return normalized === 'ok' || normalized === 'n/a' || normalized === 'issue corrected';
                        });
                        const endplateFinalStatus = isEndplateSectionPass ? 'Pass' : 'Fail';

                        const pipeStatuses = [
                            pipeTypeEval.status,
                            straightPipeEval.status,
                            singlePipeEval.status,
                            crossPipeEval.status,
                            otherPipeEval.status,
                        ];
                        const isPipePass = pipeStatuses.every(status => {
                            const normalized = status?.toLowerCase();
                            return normalized === 'ok' || normalized === 'n/a' || normalized === 'issue corrected';
                        });
                        const pipeFinalStatus = isPipePass ? 'Pass' : 'Fail';

                        const finStatuses = [
                            finsPerInchEval.status,
                            finThicknessEval.status,
                        ];
                        const isFinPass = finStatuses.every(status => {
                            const normalized = status?.toLowerCase();
                            return normalized === 'ok' || normalized === 'n/a' || normalized === 'issue corrected';
                        });
                        const finFinalStatus = isFinPass ? 'Pass' : 'Fail';

                        const assemblyStatus = [
                            afterCoilEval.status,
                        ];
                        const isAssemblyPass = assemblyStatus.every(status => {
                            const normalized = status?.toLowerCase();
                            return normalized === 'ok' || normalized === 'n/a' || normalized === 'issue corrected';
                        });
                        const assemblyFinalStatus = isAssemblyPass ? 'Pass' : 'Fail';

                        const brazingStatuses = [
                            circuitEval.status,
                            feedingEval.status,
                            liquidLineEval.status,
                            dischargeLineEval.status,
                            afterBrazingEval.status,
                        ];
                        const isBrazingPass = brazingStatuses.every(status => {
                            const normalized = status?.toLowerCase();
                            return normalized === 'ok' || normalized === 'n/a' || normalized === 'issue corrected';
                        });
                        const brazingFinalStatus = isBrazingPass ? 'Pass' : 'Fail';

                        const packingStatuses = [
                            paintTypeEval.status,
                            packingTypeEval.status,
                        ];
                        const isPackingPass = packingStatuses.every(status => {
                            const normalized = status?.toLowerCase();
                            return normalized === 'ok' || normalized === 'n/a' || normalized === 'issue corrected';
                        });
                        const packingFinalStatus = isPackingPass ? 'Pass' : 'Fail';


                        setSectionStatus({
                            Endplate: endplateFinalStatus,
                            Pipe: pipeFinalStatus,
                            Fin: finFinalStatus,
                            Assembly: assemblyFinalStatus,
                            Brazing: brazingFinalStatus,
                            Packing: packingFinalStatus,
                        });



                        const baseId = index * 1;
                        // const endplateModuleId = baseId + 1;



                        const rows = [
                            // Endplate Section
                            {
                                id: baseId + 1,
                                description: 'Length',
                                specification: item?.length || '',
                                status: lengthEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: lengthEval.remarks || '',
                            },
                            {
                                id: baseId + 2,
                                description: 'Height',
                                specification: item?.height || '',
                                status: heightEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: heightEval.remarks || '',

                            },
                            {
                                id: baseId + 3,
                                description: 'Rows',
                                specification: item?.rows || '',
                                status: rowsEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: rowsEval.remarks || '',

                            },
                            {
                                id: baseId + 4,
                                description: 'Endplate Material',
                                specification: item?.end_plate_material || '',
                                status: endplateMaterialEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: endplateMaterialEval.remarks || '',

                            },
                            {
                                id: baseId + 5,
                                description: 'Endplate Model',
                                specification: (
                                    <Button
                                        variant="text"
                                        onClick={() => {

                                            handleShowImages(epPhoto)
                                        }}
                                        sx={{ textTransform: 'none', padding: 0, minWidth: 0 }}
                                    >
                                        {item?.end_plate_modal}
                                    </Button>
                                ),
                                // specification: item?.end_plate_modal || '',
                                status: endplateModelEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: endplateModelEval.remarks || '',

                            },
                            {
                                id: baseId + 6,
                                description: 'Endplate Orientation',
                                specification: selectedRow?.orientation,

                                status: endplateOrientationEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: endplateOrientationEval.remarks || '',
                            },
                            {
                                id: baseId + 7,
                                description: 'Cover Detail',
                                specification: selectedRow?.coverDetail,
                                status: coverDetailEval.status || '',
                                section: 'Endplate',
                                finalStatus: endplateFinalStatus,
                                remarks: coverDetailEval.remarks || '',

                            },

                            // Pipe Section
                            {
                                id: baseId + 8,
                                description: 'Pipe Type',
                                specification: item?.pipe_type || '',
                                status: pipeTypeEval.status || '',
                                section: 'Pipe',
                                finalStatus: pipeFinalStatus,
                                remarks: pipeTypeEval.remarks || '',
                            },
                            {
                                id: baseId + 9,
                                description: 'Straight Pipe',
                                specification: item.pbStraight === "true" && item?.pbStraightQty && item?.pbStraightSize
                                    ? `${item.pbStraightQty}  , ${item.pbStraightSize}mm`
                                    : '',
                                status: straightPipeEval.status || '',
                                section: 'Pipe',
                                finalStatus: pipeFinalStatus,
                                remarks: straightPipeEval.remarks || '',
                            },
                            {
                                id: baseId + 10,
                                description: 'Single Pipe',

                                specification: item.pbSingle == "true" && item?.pbSingleQty && item?.pbSingleSize
                                    ? `${item.pbSingleQty}  , ${item.pbSingleSize}mm`
                                    : '',
                                status: singlePipeEval.status || '',
                                section: 'Pipe',
                                finalStatus: pipeFinalStatus,
                                remarks: singlePipeEval.remarks || '',
                            },
                            {
                                id: baseId + 11,
                                description: 'Cross Pipe',
                                specification: item?.pbCross == "true" && item?.pbCrossQty && item?.pbCrossSize
                                    ? `${item.pbCrossQty}  , ${item.pbCrossSize}mm`
                                    : '',
                                status: crossPipeEval.status || '',
                                section: 'Pipe',
                                finalStatus: pipeFinalStatus,
                                remarks: crossPipeEval.remarks || '',
                            },
                            {
                                id: baseId + 12,
                                description: 'Other Pipe',
                                specification: item?.pbOther == "true" && item?.pbOtherQty && item?.pbOtherSize
                                    ? `${item.pbOtherQty} , ${item.pbOtherSize}mm`
                                    : '',
                                status: otherPipeEval.status || '',
                                section: 'Pipe',
                                finalStatus: pipeFinalStatus,
                                remarks: otherPipeEval.remarks || '',
                            },

                            // Fin Section
                            {
                                id: baseId + 13,
                                description: 'Fins Per Inch',
                                specification: item?.fin_per_inch || '',
                                status: finsPerInchEval.status || '',
                                section: 'Fin',
                                finalStatus: finFinalStatus,
                                remarks: finsPerInchEval.remarks || '',
                            },
                            {
                                id: baseId + 14,
                                description: 'Fin Thickness',
                                specification: getThickValue(item?.fin_per_inch) || '',
                                status: finThicknessEval.status || '',
                                section: 'Fin',
                                finalStatus: finFinalStatus,
                                remarks: finThicknessEval.remarks || '',
                            },


                            // Assembly Section
                            {
                                id: baseId + 15,
                                description: 'After Coil Assembly (Drawing / Sample)',

                                specification: (
                                    <Button
                                        variant="text" // This removes the border and background
                                        onClick={() => handleShowImages(assemblyPhoto)}
                                        sx={{ textTransform: 'none', padding: 0, minWidth: 0 }}
                                    >
                                        View Images
                                    </Button>
                                ),
                                status: afterCoilEval.status || '',
                                section: 'Assembly',
                                finalStatus: assemblyFinalStatus,
                                remarks: afterCoilEval.remarks || '',
                            },
                            // Brazing Section
                            {
                                id: baseId + 16,
                                description: 'Circuit',
                                specification: item?.circuit_models || '',
                                status: circuitEval.status || '',
                                section: 'Brazing  ',
                                finalStatus: brazingFinalStatus,
                                remarks: circuitEval.remarks || '',
                            },
                            {
                                id: baseId + 17,
                                description: 'Feeding',
                                specification: item?.circuit_no || '',
                                status: feedingEval.status || '',
                                section: 'Brazing  ',
                                finalStatus: brazingFinalStatus,
                                remarks: feedingEval.remarks || '',
                            },
                            {
                                id: baseId + 18,
                                description: 'Liquid Line',
                                specification: item?.liquid || '',
                                status: liquidLineEval.status || '',
                                section: 'Brazing  ',
                                finalStatus: brazingFinalStatus,
                                remarks: liquidLineEval.remarks || '',
                            },
                            {
                                id: baseId + 19,
                                description: 'Discharge Line',
                                specification: item?.discharge || '',
                                status: dischargeLineEval.status || '',
                                section: 'Brazing  ',
                                finalStatus: brazingFinalStatus,
                                remarks: dischargeLineEval.remarks || '',
                            },
                            {
                                id: baseId + 20,
                                description: 'After Brazing (Drawing / Sample)',
                                specification: (
                                    <Button
                                        variant="text" // This removes the border and background
                                        onClick={() => handleShowImages(brazingPhoto)}
                                        sx={{ textTransform: 'none', padding: 0, minWidth: 0 }}
                                    >
                                        View Images
                                    </Button>
                                ),
                                status: afterBrazingEval.status || '',
                                section: 'Brazing  ',
                                finalStatus: brazingFinalStatus,
                                remarks: afterBrazingEval.remarks || '',
                            },

                            // Packing Section
                            {
                                id: baseId + 21,
                                description: 'Paint Type',
                                specification: item?.paintt,
                                status: paintTypeEval.status || '',
                                section: 'Packing  ',
                                finalStatus: packingFinalStatus,
                                remarks: paintTypeEval.remarks || '',
                            },
                            {
                                id: baseId + 22,
                                description: 'Packing Type',
                                specification: item?.packing,
                                status: packingTypeEval.status || '',
                                section: 'Packing  ',
                                finalStatus: packingFinalStatus,
                                remarks: packingTypeEval.remarks || '',
                            },
                        ];



                        allGeneratedRows.push(...rows);
                    }

                    setRows(allGeneratedRows);
                    setmessage(false);
                } catch (error) {
                    console.error("Error fetching inspection list:", error);
                }
            }
        };

        const debouncedFetch = debounce(fetchAndGenerate, 200);
        debouncedFetch();

    }, [selectrow, message, inputValue]);


    useEffect(() => {
        handleOrderinfo1()
    }, [])




    async function evaluateInspection(description, inspectionData) {
        let status;
        let remarks;

        if (Array.isArray(inspectionData) && inspectionData.length > 0) {
            for (const item of inspectionData) {
                if (item.measurement === description) {
                    status = item.status;
                    remarks = item.remarks;
                    break;
                }
            }
        }

        return { status, remarks };
    }

    const [issuesList, setIssuesList] = useState([]);




    const calledRef = useRef(false);


    const getIssuesList = async () => {
        const bodyFormData = new FormData();
        bodyFormData.append("authId", access);
        bodyFormData.append("order_id", selectedRow?.order_id?.replace(/\D/g, ''));

        try {
            const response = await axios.post(get_issues_list, bodyFormData);
            if (response.data && response.data.data) {
                const issuesWithSno = response.data.data.map((item, index) => ({
                    ...item,
                    sno: index + 1 // Start from 1
                }));

                setIssuesList(issuesWithSno);
            }
        } catch (error) {
            console.log(error);
        }

    };



    useEffect(() => {
        if (selectrow && !calledRef.current) {
            calledRef.current = true;
            getIssuesList();
        }
    }, []);


    const [rowModesModel, setRowModesModel] = useState({});

    const [issueDialogOpen, setIssueDialogOpen] = useState(false);

    const [currentIssue, setCurrentIssue] = useState({
        id: null,
        issueSection: '',
        issueDetails: '',
        remarks: '',
        issueimage: ""
    });

    const [issues, setIssues] = useState([
        { id: 1, issueSection: 'Brazing', issueDetails: 'RH/LH', remarks: 'Orientation Req LH - Brazed RH Identified on Line Inspection After Changes' }
    ]);



    const [currentEditingRowId, setCurrentEditingRowId] = useState(null);
    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };


    //  bodyFormData.append("authId", access);
    //     bodyFormData.append("coil_serial_no", tempSerialNumber);
    //     bodyFormData.append("order_id", selectedRow?.order_id);

    const [inspectionState, setInspectionState] = useState({
        orderInspection: [{
            measurement: "",
            order_id: "",
            status: "",
            remarks: "",
            section: "",
            final_status: ""
        }]
    });




    // const handleChange = async (event, params) => {

    //     console.log(params)
    //     const selectedValue = event.target.value;
    //     const oldRow = params.row;

    //     const newRow = {
    //         ...oldRow,
    //         status: selectedValue,
    //     };

    //     console.log("Selected Value:", selectedValue);
    //     console.log("Old Row:", oldRow);
    //     console.log("New Row:", newRow);
    //     console.log("Order ID:", newRow.order_id);
    //     console.log("Measurement:", newRow.description);

    //     // Trigger dialog if status changed to Not OK or Issue Corrected
    //     if (
    //         (newRow.status === 'Not OK' || newRow.status === 'Issue Corrected') &&
    //         (oldRow.status !== newRow.status)
    //     ) {
    //         openIssueDialog(newRow);
    //     }

    //     try {
    //         // Update the inspection state
    //         setInspectionState(prevState => {
    //             const newInspection = {
    //                 measurement: newRow.description || "", // map description to measurement
    //                 order_id: cleanedOrderId || "",
    //                 status: newRow.status || "",
    //                 remarks: newRow.remarks || "",
    //                 section: newRow.section || "",
    //                 final_status: newRow.final_status || ""
    //             };

    //             const exists = prevState.orderInspection.some(
    //                 inspection => inspection.measurement == newInspection.measurement
    //             );

    //             const updatedOrderInspection = exists
    //                 ? prevState.orderInspection.map(inspection =>
    //                     inspection.measurement === newInspection.measurement
    //                         ? { ...inspection, ...newInspection }
    //                         : inspection
    //                 )
    //                 : [...prevState.orderInspection, newInspection]
    //                     .filter(item => item.measurement !== '' || item.order_id !== '');
    //             return {
    //                 ...prevState,
    //                 orderInspection: updatedOrderInspection
    //             };
    //         });



    //         const updatedRows = rows.map(row =>
    //             row.id === newRow.id ? newRow : row
    //         );
    //         setRows(updatedRows);

    //         console.log("Row updated:", newRow);
    //     } catch (error) {
    //         console.error("Failed to update row:", error);
    //     }
    // };




    const handleChange = async (event, params) => {



        const selectedValue = event.target.value;



        const oldRow = params.row;

        const statusValue = selectedValue?.toLowerCase() === 'clear' ? null : selectedValue;

        const newRow = {
            ...oldRow,
            status: statusValue, // or the correct field name
        };

        try {
            const updatedRow = await processRowUpdate(newRow, oldRow);

            // Optionally trigger a refresh or state update here
        } catch (error) {
            console.error("Failed to update row:", error);
        }
    };




    const processRowUpdate = async (newRow, oldRow) => {
        const updatedRow = { ...newRow };

        const payload = [{
            measurement: updatedRow.description,
            order_id: cleanedOrderId,
            status: updatedRow.status,
            remarks: updatedRow.remarks,
            section: updatedRow.section,
            final_status: updatedRow.finalStatus,
        }];

        const bodyFormData = new FormData();
        bodyFormData.append("authId", access);
        bodyFormData.append("coil_serial_no", tempSerialNumber);
        bodyFormData.append("order_id", cleanedOrderId);
        bodyFormData.append("split_id", suffix);
        bodyFormData.append("orderInspection", JSON.stringify(payload));
        bodyFormData.append("modified_by", localStorage.getItem('authId')?.replace(/[0-9]/g, '') || 'Unknown',)

        try {
            const response = await axios.post(get_inspection_report, bodyFormData);
            toast.success("successfully updated");
            setmessage(true);
        } catch (error) {
            console.log(error);
        }

        if (
            (newRow.status === 'Not OK' || newRow.status === 'Issue Corrected') &&
            (oldRow.status !== newRow.status)
        ) {
            openIssueDialog(newRow);
        }

        const updatedRows = rows.map(row => (row.id === newRow.id ? updatedRow : row));
        setRows(updatedRows);

        return updatedRow;
    };


    const openIssueDialog = (row) => {

        setCurrentIssue({
            id: issues.length + 1,
            issueSection: row.section.split(" ")[0],
            issueDetails: row.status || '',
            remarks: row.remarks || ''
        });
        setCurrentEditingRowId(row?.id);
        setIssueDialogOpen(true);
    };
    const [loading, setLoading] = useState(false);
    // Issue dialog handlers
    const handleIssueDialogClose = () => {
        setIssueDialogOpen(false);
        setLoading(false);
        setImagePreview([])
    };


    const handleIssueSubmit = async () => {
        setLoading(true);
        const newIssue = { ...currentIssue };

        const updatedIssues = [...issues, newIssue];
        setIssues(updatedIssues);

        const payload = [{
            order_id: cleanedOrderId,
            issue_section: newIssue.issueSection,
            issue_detail: newIssue.issueDetails,
            remarks: newIssue.remarks,
            modified_by: localStorage.getItem('authId')?.replace(/[0-9]/g, '') || 'Unknown',
            order_serial_no: inputValue,
            customer_name: selectrow[0]?.full_customer_name,
            order_size: selectrow[0]?.size
        }];

        const formData = new FormData();
        formData.append("authId", access);
        formData.append("orderIssueDetail", JSON.stringify(payload));


        selectedFiles.forEach((file) => {
            formData.append("images[]", file);
        });

        try {
            const response = await axios.post(save_issue_list, formData);
            const res_data = response.data;
            // Optionally handle response
            toast.success("successfully add the issue images")

        } catch (error) {
            console.error("Failed to submit issue:", error);
            toast.error("Not Successfully Add The Issue Images")
            setLoading(false);
        }

        // Update remarks in the table
        if (currentEditingRowId) {
            const updatedRows = rows.map((row) => {
                if (row.id === currentEditingRowId) {
                    return { ...row, remarks: currentIssue.remarks };
                }
                return row;
            });
            setRows(updatedRows);
        }

        setIssueDialogOpen(false);
        setLoading(false);
        getIssuesList();
        setCurrentEditingRowId(null);
    };

    const handleIssueChange = (field) => (event) => {

        setCurrentIssue({
            ...currentIssue,
            [field]: event.target.value
        });
    };


    const [sectionStatus, setSectionStatus] = useState([]);

    const shouldShowIssuesList = () => {
        return rows.some(row => row.status === 'Not OK' || row.status === 'Issue Corrected') || issues.length > 0;
    };



    const statusIcons = {
        'Ok': <CheckCircle sx={{ color: 'green', mr: 1 }} />,
        'Not OK': <Cancel sx={{ color: 'red', mr: 1 }} />,
        'N/A': <Help sx={{ color: 'gray', mr: 1 }} />,
        'Issue Corrected': <Build sx={{ color: 'orange', mr: 1 }} />,
        'Clear': <ClearIcon sx={{ color: 'black', mr: 1 }} />,
    };

    const statusOptions = ['Ok', 'Not OK', 'N/A', 'Issue Corrected', 'Clear'];



    // const submitInspectionUpdate = async (
    //     row,
    //     inspectionState,
    //     access,
    //     tempSerialNumber,
    //     get_inspection_report,
    //     setmessage
    // ) => {
    //     try {
    //         // const updatedInspectionList = inspectionState.orderInspection.map(inspection =>
    //         //     inspection.measurement == row.description ? { ...inspection, ...row } : inspection
    //         // );


    //         const updatedInspectionList = inspectionState.orderInspection.map(inspection => {
    //             console.log('inspection:', inspection?.status);

    //             if (inspection.measurement == row.description) {
    //                 const updatedRow = { ...row };
    //                 // Convert "clear" to null
    //                 if (updatedRow.status && updatedRow.status.toLowerCase() == 'clear') {
    //                     updatedRow.status = null;
    //                 }
    //                 return { ...inspection, ...updatedRow };
    //             }

    //             return inspection;
    //         });


    //         const bodyFormData = new FormData();
    //         bodyFormData.append("authId", access);
    //         bodyFormData.append("coil_serial_no", tempSerialNumber);
    //         bodyFormData.append("order_id", cleanedOrderId);
    //         bodyFormData.append("orderInspection", JSON.stringify(updatedInspectionList));

    //         const response = await axios.post(get_inspection_report, bodyFormData);

    //         toast.success("Successfully updated");
    //         setmessage(true);
    //     } catch (error) {
    //         console.error("Failed to send inspection data:", error);
    //         toast.error("Update failed");
    //     }
    // };


    const columns = [
        { field: 'id', headerName: 'S.No', width: 70, align: 'center', headerAlign: 'center' },
        {
            field: 'description', headerName: 'Description', width: 400, headerAlign: 'center',
            renderCell: (params) => {
                if (params.row.colSpan && params.row.colSpan.description) {
                    return <div style={{ width: '100%' }}>{params.value}</div>;
                }
                return params.value;
            }
        },
        {
            field: 'specification', headerName: 'Specification', align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                if (params.row.colSpan && params.row.colSpan.specification) {
                    return <div style={{ width: '100%' }}>{params.value}</div>;
                }
                return params.value;
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            align: 'center',
            headerAlign: 'center',
            editable: false, // Disable default inline editing
            renderCell: (params) => {
                const value = params.value; // Fix: get current value
                return (
                    <Select
                        value={value || ''}
                        onChange={(event) => handleChange(event, params)}
                        fullWidth
                        size="small"
                    >
                        {statusOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                <Box display="flex" alignItems="center">
                                    {statusIcons[option]}
                                    <Typography variant="body2" sx={{ ml: 1 }}>
                                        {option}
                                    </Typography>
                                </Box>
                            </MenuItem>
                        ))}
                    </Select>
                );
            },
        },

        {
            field: 'remarks',
            headerName: 'Remarks',
            headerAlign: 'center',
            editable: true,
            renderCell: (params) => {
                const value = params.formattedValue || '';
                const isScrollable = value.length > 10;
                return (
                    <div className={isScrollable ? 'issueRemarkScroll' : ' '}>
                        {value}
                    </div>
                );
            }
        },


        {
            field: 'section',
            headerName: 'Section',
            align: 'center',
        },
        {
            field: 'finalStatus',
            headerName: 'Final Status',
            align: 'center',
            headerAlign: 'center',
        },
        // {
        //     field: 'actions',
        //     headerName: 'Submit',
        //     align: 'center',
        //     headerAlign: 'center',
        //     width: 100,

        //     rowSpanValueGetter: (value, row) => {
        //         return row ? `${row.section}-${row.finalStatus}` : value;
        //     },

        //     renderCell: (params) => {
        //         const row = params.row;

        //         return (
        //             <Button
        //                 variant="text"
        //                 color="primary"
        //                 size="small"
        //                 onClick={() =>
        //                     submitInspectionUpdate(
        //                         row,
        //                         inspectionState,
        //                         access,
        //                         tempSerialNumber,
        //                         get_inspection_report,
        //                         setmessage
        //                     )
        //                 }
        //             >
        //                 Submit
        //             </Button>
        //         );
        //     }
        // }

    ];



    const rootStyles = {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        "& .section-odd, & .finalStatus-odd": {
            backgroundColor: "#FFE1D6 !important",
            alignItems: "center !important",
        },
        "& .section-even, & .finalStatus-even": {
            backgroundColor: "#F2F2F2 !important",
            alignItems: "center !important",
        },

        "& .actions-odd": {
            backgroundColor: "#FFE1D6 !important", // Changed to match odd pattern
            alignItems: "center !important",
        },
        "& .actions-even": { // Added missing even case
            backgroundColor: "#F2F2F2 !important",
            alignItems: "center !important",
        }
    };

    // const slotColumnCommonFields = {
    //     sortable: false,
    //     filterable: false,
    //     pinnable: false,
    //     hideable: false,
    //     cellClassName: (params) => {
    //         console.log(params.row?.id);
    //         return `${params?.field}-${params.row?.id % 2 === 0 ? 'even' : 'odd'
    //             }`;
    //     },
    // };


    const sectionOrder = ['Endplate', 'Pipe', 'Fin', 'Assembly', 'Brazing', 'Packing'];
    const statusValues = ['Pass', 'Fail'];

    const slotColumnCommonFields = {
        sortable: false,
        filterable: false,
        pinnable: false,
        hideable: false,
        cellClassName: (params) => {
            const section = params.row?.section?.trim();
            if (section && sectionOrder.includes(section)) {
                const index = sectionOrder.findIndex(s => s === section);
                const isEven = index % 2 === 0;
                return `${params?.field}-${isEven ? 'odd' : 'even'}`;
            }


            //     const finalStatus = params.row?.finalstatus?.trim();

            //    if(finalStatus && statusValues.includes(finalStatus)){
            //         const index = statusValues.findIndex(s => s === finalStatus);
            //         const isEven = index % 2 == 0;
            //         return `${params?.field}-${isEven ? 'odd' : 'even'}`;
            //     }

            return '';
        },
    };



    // <Button onClick={() => setTempSerialNumber(inputValue)}>Save</Button>

    const size = selectedRow?.size;
    const sizeNumber = parseInt(size?.split('-')[1], 10);
    const sizeOptions = Array.from({ length: sizeNumber }, (_, i) => i + 1);
    const serialNumberOptions = selectedRow?.serial_no
        ? selectedRow?.serial_no
            .split(',')
            .filter(Boolean)
            .map((id) => ({ id, label: id }))
        : [];

    const sectionClassMap = {};

    let sectionCounter = 0;

    function getSectionClass(section) {
        if (!(section in sectionClassMap)) {
            sectionClassMap[section] = sectionCounter % 2 === 0 ? 'Mui-even' : 'Mui-odd';
            sectionCounter++;
        }
        return sectionClassMap[section];
    }



    const [openDialog, setOpenDialog] = useState(false);



    let endPlateImages = epPhoto?.length ? epPhoto : [];
    let assemblyImages = assemblyPhoto?.length ? assemblyPhoto : [];
    let brazingImages = brazingPhoto?.length ? brazingPhoto : [];
    let allImages = [...endPlateImages, ...assemblyImages, ...brazingImages];

    const handleOrderinfo1 = () => {


        const bodyFormData = new FormData();
        bodyFormData.append("authId", access);
        bodyFormData.append("id", orderRowID);

        axios({
            method: "post",
            url: getOrderDataByID,
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                const res_data = response.data;

                if (res_data.status_code === 101) {
                    toast.error("API authentication failed. Please login again.");
                } else if (res_data.status_code === 200) {
                    const orderData = res_data.data_orders?.[0];

                    if (orderData) {
                        setEpPhoto(orderData.ep_photo || []);
                        setAssemblyPhoto(orderData.assembly_Photo || []); // ensure consistent casing
                        setBrazingPhoto(orderData.brazing_Photo || []);
                    } else {
                        toast.warning("No order data found.");
                    }
                } else {
                    toast.warning(res_data.status_msg || "Unexpected API response.");
                }
            })
            .catch((error) => {
                console.error("API call failed:", error);
                toast.error("Failed to fetch order info.");
            });
    };









    const [imagePreview, setImagePreview] = useState([]);

    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(files);

        const previews = files.map((file) => URL.createObjectURL(file));
        setImagePreview(previews);
    };


    const [open1, setOpen1] = useState(false);
    const [selectedImage, setSelectedImage] = useState([]);

    const handleOpen = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen1(false);
        setSelectedImage([]);
    };

    const handleRemoveImage = (indexToRemove) => {
        setImagePreview(prev => prev.filter((_, index) => index !== indexToRemove));
    };


    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [orderId, setorderId] = useState(null);


    const handleDeleteRow = (params) => {
        setSelectedOrderId(params.row.id);
        setorderId(params.row.order_id);
        setOpenDeleteDialog(true);
    };


    const handleDeleteConfirmed = () => {
        const formData = new FormData();
        formData.append('id', selectedOrderId);
        formData.append("authId", access);

        axios({
            method: 'post',
            url: delete_order_issue,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                const res_data = response.data;
                if (res_data.status_code === 101) {
                    toast.error("API authentication failed. Please login again.");
                } else if (res_data.status_code === 200) {
                    toast.success("Order deleted successfully.");
                    setIssuesList(prev => prev.filter(item => item.id !== selectedOrderId));
                    setOpenDeleteDialog(false);
                } else {
                    toast.warning(res_data.status_msg || "Unexpected API response.");
                }
            })
            .catch((error) => {
                console.error("Delete API failed:", error);
                toast.error("Failed to delete order.");
            });
    };




    return (
        <Box style={{ width: '100%', mb: 4 }} sx={rootStyles} >
            <Paper elevation={3} sx={{ mb: 3, p: { xs: 1, sm: 2 }, backgroundColor: '#f8f9fa' }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    mb: 2,
                    gap: 1
                }}>
                    <Typography variant="h5" component="h1" sx={{
                        fontWeight: 'bold',
                        color: '#d96e27',
                        fontSize: { xs: '1.2rem', sm: '1.5rem' }
                    }}>
                        FINAL INSPECTION REPORT
                    </Typography>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Typography className="reports"><strong>Customer Name:</strong> {selectedRow?.full_customer_name}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography className="reports"><strong>Order Number:</strong> {selectedRow?.order_id}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography className="reports"><strong>Coil Size:</strong> {selectedRow?.size}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{
                            backgroundColor: '#d96e27', p: 1, color: 'white', display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <Typography sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: 'center',
                                gap: 1
                            }}>
                                <strong>Coil Serial Number:</strong>
                                <Select
                                    size="small"
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    displayEmpty
                                    variant="outlined"
                                    sx={{ backgroundColor: 'white', minWidth: 150 }}
                                >
                                    {/* <MenuItem value="" disabled>Select Quantity</MenuItem>
                                    {sizeOptions.map((num) => (
                                        <MenuItem key={num} value={num}>{num}</MenuItem>
                                    ))} */}
                                    <MenuItem value="" disabled>Select Quantity</MenuItem>

                                    {(serialNumberOptions && serialNumberOptions.length > 0
                                        ? serialNumberOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.label}
                                            </MenuItem>
                                        ))
                                        : sizeOptions.map((num) => (
                                            <MenuItem key={num} value={num}>
                                                {num}
                                            </MenuItem>
                                        ))
                                    )}
                                </Select>
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            <Card >
                <Paper elevation={3}  >
                    <DataGrid
                        rows={rows}
                        // columns={columns}
                        columns={columns.map((data) => ({
                            ...data,
                            // Handle section and finalStatus columns
                            ...(data.field === 'section' || data.field === 'finalStatus'
                                ? {
                                    width: 80,
                                    rowSpanValueGetter: (value, row) => {
                                        return row ? `${row.section}-${row.finalStatus}` : value;
                                    }
                                }
                                : {}),


                            ...(data.field === 'actions'
                                ? {
                                    width: 80,
                                    // cellClassName: (params) => {
                                    //     // params.row gives you access to the full row data
                                    //     // params.value gives you the cell value
                                    //     console.log('Row data:', params.row);
                                    //     return params.row ? `actions-id-${params.row.id}` : '';
                                    // }
                                }
                                : {}),

                            // Handle other columns (default case)
                            ...(data.field !== 'section' && data.field !== 'finalStatus' && data.field !== 'actions'
                                ? {
                                    flex: 1,
                                    rowSpanValueGetter: (value, row) => {
                                        return row ? `${row.section}-${row.finalStatus}-${row.id}` : value;
                                    }
                                }
                                : {}),

                            ...slotColumnCommonFields,
                        }))}



                        editMode="row"
                        rowModesModel={rowModesModel}
                        onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
                        // onRowEditStop={handleRowEditStop}
                        processRowUpdate={processRowUpdate}
                        components={{ Toolbar: GridToolbar }}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'id', sort: 'asc' }],
                            },
                        }}

                        getRowClassName={(params) => {
                            const { priority, tcutting_status, finpunch_status, section, finalStatus } = params.row;

                            if (priority === 'true') {
                                return 'secon-bg';
                            } else if (tcutting_status === 'true' && finpunch_status === 'true') {
                                return 'partial-comp-bg';
                            } else {
                                return getSectionClass(section);
                            }

                        }}





                        // getRowClassName={(params) => {

                        //     if (params.indexRelativeToCurrentPage % 2 === 0) {
                        //         if (params.row.priority === 'true') {
                        //             return 'secon-bg';
                        //         } else if (
                        //             params.row.tcutting_status === 'true' &&
                        //             params.row.finpunch_status === 'true'
                        //         ) {
                        //             return 'partial-comp-bg';
                        //         }
                        //          else {
                        //             return 'Mui-even';
                        //         }
                        //     } else {
                        //         if (params.row.priority === 'true') {
                        //             return 'secon-bg';
                        //         } else if (
                        //             params.row.tcutting_status === 'true' &&
                        //             params.row.finpunch_status === 'true'
                        //         ) {
                        //             return 'partial-comp-bg';
                        //         } 
                        //         else {
                        //             return 'Mui-odd';
                        //         }
                        //     }
                        // }}
                        sx={{

                            "& .MuiDataGrid-root": {
                                width: "100% !important",
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: '#943612',
                                color: 'white',
                            },
                            '.MuiDataGrid-row.Mui-odd ': {
                                backgroundColor: '#FFE1D6',
                            },
                            '.MuiDataGrid-row.Mui-even ': {
                                backgroundColor: '#F2F2F2',
                            },
                            '.MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell': {
                                whiteSpace: 'break-spaces',
                                padding: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                            },
                            '.MuiDataGrid-columnHeaderTitleContainer': {
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                            },
                            '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
                                border: '.5px solid white',
                            },
                            '& .MuiInputBase-input': {
                                fontSize: '0.74rem',
                                padding: '16.5px 1px ',
                            },

                        }}
                        unstable_rowSpanning={true}
                    />

                </Paper>
            </Card>
            {/* Summary Section */}
            <Paper elevation={3} sx={{ mt: 3, p: 2, backgroundColor: '#f8f9fa' }}>
                <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Section Summary
                </Typography>
                <Grid container spacing={2}>
                    {Object.entries(sectionStatus).map(([section, status], index) => (
                        <Grid item xs={4} key={index}>
                            <Box
                                sx={{
                                    p: 1,
                                    bgcolor: status === 'Pass' ? '#d8e4bc' : status === 'Fail' ? '#f2dcdb' : '#f0f0f0', // Fallback color for 'Pending'
                                    borderRadius: 1,
                                    textAlign: 'center',
                                }}
                            >
                                <Typography sx={{ fontWeight: 'bold' }}>
                                    {section}:{' '}
                                    <span style={{ color: status === 'Pass' ? '#006100' : status === 'Fail' ? '#9c0006' : '#808080' }}>
                                        {status || 'Pending'}
                                    </span>
                                </Typography>
                            </Box>
                        </Grid>
                    ))}


                </Grid>
            </Paper>


            {shouldShowIssuesList() && (
                <Paper elevation={3} sx={{ mt: 3, p: 2, backgroundColor: '#f8f9fa' }}>
                    <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Issues List
                    </Typography>
                    <DataGrid
                        rows={issuesList}
                        getRowHeight={() => 'auto'}
                        columns={[
                            { field: 'sno', headerName: 'S.No', width: 70, align: 'center', headerAlign: 'center' },
                            { field: 'order_id', headerName: 'Order NO', width: 200, headerAlign: 'center' },
                            {
                                field: 'file_name',
                                headerName: 'Images',
                                width: 150,
                                headerAlign: 'center',
                                align: 'center',
                                renderCell: (params) => {
                                    let imageUrls = [];

                                    try {
                                        imageUrls = JSON.parse(params.value);
                                    } catch (error) {
                                        console.error('Invalid image URL JSON:', error);
                                    }

                                    return imageUrls.length > 0 ? (
                                        <Button
                                            variant="text"
                                            color="primary"
                                            onClick={() => handleOpen(imageUrls)}
                                            size="small"
                                        >
                                            View Images
                                        </Button>
                                    ) : (
                                        <span>No Image</span>
                                    );
                                }
                            },
                            { field: 'created_date', headerName: 'Create Date', width: 200, headerAlign: 'center' },
                            { field: 'issue_section', headerName: 'Issue Section', width: 150, align: 'center', headerAlign: 'center' },
                            {
                                field: 'issue_detail', headerName: 'Issue Details', width: 200, headerAlign: 'center',
                                renderCell: (params) => {
                                    const value = params.formattedValue || '';

                                    return (
                                        <div className={'issueRemarkScroll'} >
                                            {value}
                                        </div>
                                    );
                                }
                            },
                            // { field: 'remarks', headerName: 'Remarks', width: 400, headerAlign: 'center' },

                            {
                                field: 'remarks',
                                headerName: 'Remarks',
                                width: 400,
                                headerAlign: 'center',
                                align: 'center',
                                renderCell: (params) => {
                                    const value = params.formattedValue || '';
                                    // const isScrollable = value.length > 30;
                                    return (
                                        <div className={'issueRemarkScroll'}>
                                            {value}
                                        </div>
                                    );
                                }
                            },

                            {
                                field: 'actions',
                                headerName: 'Actions',
                                width: 100,
                                headerAlign: 'center',
                                align: 'center',
                                sortable: false,
                                filterable: false,
                                renderCell: (params) => {
                                    const orderId = params.row.order_id;

                                    return (
                                        <IconButton
                                            onClick={() => handleDeleteRow(params)}
                                            color="error"
                                            size="small"
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    );
                                }
                            }

                        ]}
                        autoHeight
                        disableSelectionOnClick
                        sx={{
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#d96e27",
                                color: "white",
                            },
                            ".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell": {
                                whiteSpace: "break-spaces",
                                padding: 0,
                                display: "flex",
                                justifyContent: "center",
                                fontSize: "0.75rem",
                            },
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                justifyContent: 'center', // Horizontal center
                                alignItems: 'center',     // Vertical center
                                textAlign: 'center',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                lineHeight: '1.5rem',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                minHeight: '56px !important',
                                maxHeight: '56px !important',
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                width: '100%',
                                textAlign: 'center',
                                fontWeight: 600,
                            },
                        }}
                    />
                </Paper>
            )}

            {/* Issue Dialog */}
            <Dialog open={issueDialogOpen} onClose={handleIssueDialogClose} maxWidth="md" fullWidth>
                <DialogTitle sx={{ backgroundColor: '#d96e27', color: 'white' }}>
                    Add Issue Details
                </DialogTitle>
                <DialogContent sx={{ mt: 3 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel>Issue Section</InputLabel>
                                <Select
                                    value={currentIssue.issueSection}
                                    onChange={handleIssueChange('issueSection')}
                                    label="Issue Section"
                                >
                                    <MenuItem value="Endplate">Endplate</MenuItem>
                                    <MenuItem value="Pipe">Pipe</MenuItem>
                                    <MenuItem value="Fin">Fin</MenuItem>
                                    <MenuItem value="Assembly">Assembly</MenuItem>
                                    <MenuItem value="Brazing">Brazing</MenuItem>
                                    <MenuItem value="Packing">Packing</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Issue Details"
                                // value={currentIssue.issueDetails}
                                onChange={handleIssueChange('issueDetails')}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Remarks"
                                value={currentIssue.remarks}
                                onChange={handleIssueChange('remarks')}
                                multiline
                                rows={4}
                            />
                        </Grid>

                        <Grid container item xs={12} >
                            <FormControl fullWidth>
                                <input
                                    accept="image/*"
                                    id="upload-image"
                                    type="file"
                                    multiple
                                    style={{ display: 'none' }}
                                    onChange={handleImageChange}
                                />
                                <label htmlFor="upload-image">
                                    <Button variant="outlined" component="span" fullWidth>
                                        Upload Issue Image
                                    </Button>
                                </label>
                            </FormControl>

                            {imagePreview.length > 0 && (
                                <Grid item xs={12} className="mt-4">
                                    <Typography variant="subtitle1" className="mb-2">
                                        Previews:
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {imagePreview.map((src, index) => (
                                            <Grid item xs={6} sm={4} md={3} key={index}>
                                                <Box className="border border-gray-300 rounded p-2">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleRemoveImage(index)}
                                                        className="absolute top-0 right-0 z-10"
                                                        style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                    <img
                                                        src={src}
                                                        alt={`Preview ${index}`}
                                                        className="w-full object-contain max-h-64"
                                                    />
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            )}

                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions sx={{ p: 2, display: 'flex', }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ mr: 2 }}>
                            Checked By: {localStorage.getItem('authId')?.replace(/[0-9]/g, '') || 'Unknown'}
                        </Typography>
                    </Box>
                    <Button onClick={handleIssueDialogClose} variant="outlined">Cancel</Button>
                    {loading ? (
                        <PuffLoader size={24} color="#943612" />
                    ) : (
                        <Button
                            onClick={handleIssueSubmit}
                            variant="contained"
                            sx={{
                                backgroundColor: '#d96e27',
                                '&:hover': { backgroundColor: '#943612' }
                            }}
                        >
                            Save Issue
                        </Button>
                    )}

                </DialogActions>
            </Dialog>
            {/* <Dialog open={openDialog} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle>All Images</DialogTitle>
                <DialogContent>
                    <ImageList cols={3} gap={8}>
                        {imageList.map((img, index) => (
                            <ImageListItem key={index}>
                                <img
                                    src={img.src}
                                    alt={img.title}
                                    loading="lazy"
                                    style={{ borderRadius: 8 }}
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </DialogContent>
            </Dialog> */}
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Images</DialogTitle>
                <DialogContent dividers>
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                            justifyContent: 'center',
                        }}
                    >
                        {dialogImages.length === 0 ? (
                            <Typography variant="body2">No images available</Typography>
                        ) : (
                            <ImageList
                                cols={3}
                                gap={16}
                                sx={{
                                    width: '100%',
                                    maxWidth: 800,
                                }}
                            >
                                {dialogImages.map((img, index) => (
                                    <ImageListItem key={index}>
                                        <img
                                            src={imageURL + img}
                                            alt={`Image ${index}`}
                                            loading="lazy"
                                            style={{
                                                width: '100%',
                                                height: '200px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                            }}
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                        )}
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} variant="contained" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={open1} onClose={handleClose} maxWidth="md" fullWidth>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent style={{ textAlign: 'center' }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 16 }}>
                        {Array.isArray(selectedImage) ? (
                            selectedImage.map((url, idx) => (
                                <img
                                    key={idx}
                                    src={url}
                                    alt={`Image ${idx + 1}`}
                                    style={{ maxWidth: '700px', maxHeight: '500px', borderRadius: 8 }}
                                />
                            ))
                        ) : (
                            <img
                                src={selectedImage}
                                alt="Selected"
                                style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 8 }}
                            />
                        )}
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete order issues?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
                        No
                    </Button>
                    <Button onClick={handleDeleteConfirmed} color="error" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>



        </Box >
    );
}

export default QualityInspectionReport;